export default {
  searchSubmit: 'searchSubmit',
  isLoading: 'isLoading',
  globalSearchSubmit: 'globalSearchSubmit',
  isGlobalSearchActive: 'isGlobalSearchActive',
  globalClearAllFilters: 'globalClearAllFilters',
  globalClearSearch: 'globalClearSearch',
  formAddError: 'formAddError'
};
